import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const RepProfileFunctionality = { id: 15, name: 'Rep Profiles' };
export const repTwoMinuteSummaryTool = defineFeature({
    type: FeatureType.Boolean,
    propName: 'rep_two_minute_summary_tool',
    uiName: 'repTwoMinuteSummaryTool',
    displayName: 'Rep Two Minute Summary Tool Enabled',
    description: 'Enable the tool that returns the current subject rep two minute summary',
    category: RepProfileFunctionality,
    areas: ['agent'],
    codec: 'identity',
    schema: z.boolean(),
    default: false,
    isSystem: true,
    surfacedIn: ['agent'],
});
export const repAutocompleteEndpoint = defineFeature({
    type: FeatureType.Json,
    propName: 'rep_autocomplete_endpoint',
    uiName: 'repAutocompleteEndpoint',
    displayName: 'Rep Autocomplete Endpoint',
    description: 'Configure the data connection and relative endpoint path used for rep autocomplete lookups',
    category: RepProfileFunctionality,
    areas: [],
    codec: 'identity',
    schema: z
        .object({
        connectionIdentifier: z.string().min(1),
        path: z.string().startsWith('/'),
    })
        .nullable(),
    default: null,
    isSystem: true,
    editor: 'data-connection-endpoint',
});
export const repSearchEndpoint = defineFeature({
    type: FeatureType.Json,
    propName: 'rep_search_endpoint',
    uiName: 'repSearchEndpoint',
    displayName: 'Rep Search Endpoint',
    description: 'Configure the data connection and relative endpoint path used for rep search lookups',
    category: RepProfileFunctionality,
    areas: [],
    codec: 'identity',
    schema: z
        .object({
        connectionIdentifier: z.string().min(1),
        path: z.string().startsWith('/'),
    })
        .nullable(),
    default: null,
    isSystem: true,
    editor: 'data-connection-endpoint',
});
export const repProfileFunctionalityFeatures = [
    repTwoMinuteSummaryTool,
    repAutocompleteEndpoint,
    repSearchEndpoint,
];
